// extracted by mini-css-extract-plugin
export default {"container":"FeatureCards_container__h3OpN"};